var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLovable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 122,
    viewBox: "0 0 121 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_572_319",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 121,
    height: 122
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0687 0C55.9888 0 72.1373 16.1551 72.1373 36.0835V49.7975H84.141C104.061 49.7975 120.21 65.9526 120.21 85.8809C120.21 105.809 104.061 121.964 84.141 121.964H0V36.0835C0 16.1551 16.1485 0 36.0687 0Z",
    fill: "url(#paint0_linear_572_319)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_572_319)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_572_319)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.7381,
    cy: 65.1011,
    rx: 81.3729,
    ry: 81.1923,
    fill: "#4B73FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_572_319)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.6734,
    cy: 20.547,
    rx: 104.216,
    ry: 81.1923,
    fill: "#FF66F4"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_572_319)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.6659,
    cy: 5.26802,
    rx: 81.3729,
    ry: 71.3042,
    fill: "#FF0105"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_572_319)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.121,
    cy: 20.5275,
    rx: 48.9374,
    ry: 48.8288,
    fill: "#FE7B02"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_572_319",
    x: -65.0219,
    y: -52.4784,
    width: 235.52,
    height: 235.159,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.1936,
    result: "effect1_foregroundBlur_572_319"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_572_319",
    x: -78.9301,
    y: -97.0324,
    width: 281.208,
    height: 235.159,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.1936,
    result: "effect1_foregroundBlur_572_319"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_572_319",
    x: -39.0942,
    y: -102.423,
    width: 235.52,
    height: 215.383,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.1936,
    result: "effect1_foregroundBlur_572_319"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_572_319",
    x: -22.2036,
    y: -64.6884,
    width: 170.649,
    height: 170.432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.1936,
    result: "effect1_foregroundBlur_572_319"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_572_319",
    x1: 40.4527,
    y1: 21.4331,
    x2: 76.9327,
    y2: 121.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#FF8E63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FF7EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#4B73FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLovable);
export default __webpack_public_path__ + "static/media/lovable.e7abcc51d638d2b688f9961e22440268.svg";
export { ForwardRef as ReactComponent };